'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.closeThreadMessageReceived = undefined;

var _postConversationClosedEvent = require('../../threads/actions/postConversationClosedEvent');

var closeThreadMessageReceived = exports.closeThreadMessageReceived = function closeThreadMessageReceived(_ref) {
  var thread = _ref.thread;
  return function (dispatch) {
    dispatch((0, _postConversationClosedEvent.postConversationClosedEvent)({ thread: thread }));
  };
};


//////////////////
// WEBPACK FOOTER
// ./js/pubsub/actions/closeThreadMessageReceived.js
// module id = 426
// module chunks = 2 3